import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import UI from "../../shared/Components/UI/js";
import AdminCmsLguPartnersTable from "./AdminCmsLguPartnersTable";
import MainLayout from "../_components/MainLayout";
const context = "admin";

export default class AdminCmsLguPartners extends Component {
  constructor(props) {
    super(props);
    UI.initiateView(this, {
      //Initial State Here
      active_tab: "App Content",
      is_drawer_open: false,
      selected: null,
      current_page: 1,
      context: context,
    });
  }

  render() {
    const _this = this;
    return (
      <MainLayout context={context} additional={"lgu-partners"} _this={_this}>
        <AdminCmsLguPartnersTable _this={_this} />
      </MainLayout>
    );
  }
}
